<template>
  <div>
    <legend>Недоставленные заказы</legend>
    <table class="table table-sm table-bordered table-hover table-cell-align-middle">
      <thead>
      <tr>
        <th width="100">Номер</th>
        <th>Название</th>
        <th width="70">Дата клиента</th>
        <th width="70">Дата оформления</th>
        <th width="70">Дата отправки</th>
        <th width="70">Цена</th>
      </tr>
      </thead>
      <tbody class="w-100">
      <template v-for="tour in groupedOrders">
        <template v-for="reception in tour">
          <template v-for="(order, index) in reception">
            <template v-if="index === 0">
              <tr>
                <td class="font-weight-bold">{{tours[order.TourId].Name}}</td>
                <td class="font-weight-bold" colspan="5">{{points[order.PointId].Reception}}</td>
              </tr>
            </template>
            <tr>
              <td class="text-nowrap">
                <router-link
                  target="_blank"
                  :to="{ name: 'order-info', params: {orderId: order.Id}}">
                  {{order.RecastNumber > 0 ? 'Переделка заказа ' : ''}}
                  {{order.SferaNumber}}
                  {{order.LocalNumber && (`/ ${order.LocalNumber}`)}}
                </router-link>
              </td>
              <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis">
                {{order.Name}}
              </td>
              <td class="text-nowrap">
                {{order.CustomerDate}}
              </td>
              <td class="text-nowrap">
                {{order.ReceivedDate}}
              </td>
              <td class="text-nowrap">
                {{order.DispatchDate}}
              </td>
              <td class="text-nowrap">
                {{order.Summary}}
              </td>
            </tr>
          </template>
        </template>

      </template>

      </tbody>
    </table>
  </div>
</template>
<script>
import _ from 'lodash';
import {get} from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
export default {
  data() {
    return {
      orders: [],
      points: {},
      tours: {},
    };
  },
  async mounted() {
    await this.fetchUndeliveredOrders();
  },
  computed: {
    groupedOrders() {
      if (!this.orders) return [];
      let col = _.groupBy(this.orders, 'TourId');
      const orderedTours = _.orderBy(this.tours, 'Name');
      col = _.sortBy(col, item => orderedTours.indexOf(item.TourId));
      col = _.map(col, (orders) => {
        const byPoint = _.groupBy(orders, 'PointId');
        return _.orderBy(byPoint, 'Reception');
      });
      return col;
    },
  },
  methods: {
    async fetchUndeliveredOrders() {
      const {data} = await get(`${url}/undelivered`);
      this.orders = data.orders;
      this.points = data.points;
      this.tours = data.tours;
    },
  },
};
</script>
